export default __webpack_public_path__ + "static/media/cash.b96e4d4d.svg";